import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
    name: 'localizeDate',
    pure      : false,
    standalone: true,
})
export class LocalizeDatePipe implements PipeTransform {

    constructor(private translate: TranslocoService) { }

    transform(value: string | number | Date, format: string = 'mediumDate'): string {
        const datePipe = new DatePipe(this.translate.getActiveLang());
        return datePipe.transform(value, format/* , 'UTC' */);
    }

}
